import { memo, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import toast from "react-hot-toast";
import axios from "axios";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { unitSchema } from "../../app/schema";
import { useDispatch } from "react-redux";
import { showModal, hideConfirmModal } from "../../redux/counterSlice";
import { FormInputText } from "../../components/form-components/FormInputText";

function AddUnit({
  open,
  handleClose,
  selectedRow: selectedUnitRow,
  loadInitialData,
}) {
  const dispatch = useDispatch();
  const isEditMode = selectedUnitRow && selectedUnitRow.unit_id;

  const methods = useForm({
    resolver: yupResolver(unitSchema),
    defaultValues: {
      unit_name: "",
      active_status: false,
    },
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = methods;

  useEffect(() => {
    if (selectedUnitRow) {
      reset({
        unit_id: {
          value: selectedUnitRow?.unit_id,
          label: selectedUnitRow?.unit_name,
        },
        unit_name: selectedUnitRow?.unit_name || "",
        active_status: selectedUnitRow?.active_status || false,
      });
    } else {
      reset({
        unit_name: "",
        active_status: false,
      });
    }
  }, [selectedUnitRow, reset]);

  const onSubmit = async (data) => {
    const payload = {
      unit_name: data.unit_name,
      active_status: data.active_status,
      ...(isEditMode && { unit_id: selectedUnitRow.unit_id }),
    };

    try {
      const endpoint = isEditMode ? "/updateUnit" : "/createUnit";
      const response = await axios.post(endpoint, payload);

      if (!response?.data?.error) {
        toast.success(response?.data?.message || "Saved successfully");
        loadInitialData();
        reset();
        handleClose();
      } else {
        let errDesc = response?.data?.message || "Something went wrong";
        if (response?.data?.data) {
          errDesc = Object.values(response.data.data).join("\n");
        }
        dispatch(showModal({ msg: errDesc, error: true }));
      }
    } catch (error) {
      dispatch(
        showModal({ msg: error?.message || "Server error", error: true })
      );
    } finally {
      dispatch(hideConfirmModal({ msg: "" }));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle className="text-primary">
        {isEditMode ? "Edit Unit" : "Add Unit"}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormInputText
              name="unit_name"
              control={control}
              label="Unit Name"
              errors={errors}
              mandatory="true"
              style={{ marginTop: isEditMode ? 16 : 0 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="error">
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          startIcon={<SaveIcon />}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(AddUnit);
